import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { get } from '../apiClient'
import {
  listReservationsResponseSchema,
  ReservationResponse,
} from '../../../common/validations/reservationSchema'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

export type CreateReservationRequest = ReservationResponse

const params = (contractUuid: string) => {
  const path = API_ENDPOINTS.RESERVATIONS.replace(':contractUuid', contractUuid)

  return {
    queryKey: ['reservations', contractUuid],
    queryFn: async () => {
      return get(path, listReservationsResponseSchema)
    },
  }
}

export const useAPIGetReservations = (contractUuid: string) => {
  return useQuery(params(contractUuid))
}

export const useAPIGetReservationsSuspense = (contractUuid: string) => {
  return useSuspenseQuery(params(contractUuid))
}
